import { RadioButtonWithLabelOption, TextLinkWidget } from '@tableau/widgets';
import React from 'react';

import { FormikRadioButtonGroup } from '~commonInfra/components/FormikRadioButtonGroup';
import { FeatureFlags } from '~commonInfra/featureFlags/FeatureFlags';
import { HelpService } from '~commonInfra/services/HelpService';
import { SessionServerSelectors } from '~src/bootstrap/redux/selectors/SessionInfoSelectors';

import { Messages } from '../../../../../codegen/Localize';
import { SettingsSection } from '../../../../components/common/SettingsSection';
import { learnMoreStyle, settingsRadioButtonItemHeight } from '../../../../styles/CommonStyles';
import { useSelector } from '../../../utils';
import { componentRegistryEntry } from '../../SettingsComponentRegistryFunctions';
import { SiteSettingsForSiteAdminProps } from '../../site-settings/ReactSiteSettingsForSiteAdmin';

export const AFE_ENABLED = 'settings.alternativeFederationEngineEnabled';
export type CrossDataBaseJoinsSectionProps = SiteSettingsForSiteAdminProps<'alternativeFederationEngineEnabled'>;

export function CrossDataBaseJoinsSection(props: CrossDataBaseJoinsSectionProps) {
  const afeUiSettingEnabled = useSelector(SessionServerSelectors.isAfeUiSettingEnabled);
  return FeatureFlags.alternativeFederationEngineUserInterface
    ? (
      <SettingsSection title={Messages.crossDatabaseJoins()}
                       testId={'alternative-federation-engine-site-setting'}
                       description={renderDescription()}
                       disabled={!afeUiSettingEnabled}>
        <FormikRadioButtonGroup name={AFE_ENABLED}
                                buttonList={getButtons(afeUiSettingEnabled)}
                                testId={'cross-database-joins-options'}
                                className={settingsRadioButtonItemHeight}
                                ariaLabel={Messages.crossDatabaseJoins()}>
        </FormikRadioButtonGroup>
      </SettingsSection>
    ) : null;
}

function renderDescription() {
  return <>
    <span data-tb-test-id='cross-database-joins-description'>{Messages.crossDatabaseJoinsMsg()}</span>
    <TextLinkWidget testId={'cross-database-joins-learn-more-link'}
                    className={learnMoreStyle}
                    href={HelpService.getServerHelpUrlByCategory('cross-dbase-join-admin')}
                    target={'_blank'}>
      {Messages.learnMore()}
    </TextLinkWidget>
  </>;
}

function getButtons(afeUiSettingEnabled: boolean): RadioButtonWithLabelOption<boolean>[] {
  return [{
    testId: 'cross-database-joins-enabled-radio-button',
    label: <>
        <div>{afeUiSettingEnabled ? Messages.crossDatabaseJoinsOn() : Messages.crossDatabaseJoinsOnDisabledInServerConfig()}</div>
        <div>{Messages.crossDatabaseJoinsOnDescription()}</div>
      </>,
    value: true,
    disabled: !afeUiSettingEnabled
  }, {
    testId: 'cross-database-joins-disabled-radio-button',
    label: <>
        <div>{Messages.crossDatabaseJoinsOff()}</div>
        <div>{Messages.crossDatabaseJoinsOffDescription()}</div>
      </>,
    value: false,
    disabled: !afeUiSettingEnabled
  }];
}

export const CrossDataBaseJoinsSectionSpecs = componentRegistryEntry({
  name: 'CrossDataBaseJoinsSection',
  component: CrossDataBaseJoinsSection
});
